import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index.vue'
import LocalStorageService from "@/common/LocalStorageService";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        requiresAuth: false
      },
      component: Index
    },

    {
      path: '/thanks',
      name: 'success',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/Thanks.vue')
    },
  
    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },

    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '*', 
      component: Index
    }
  ]
});

let announcer = document.getElementById('announcer');
router.afterEach(function(to) {
  if (!to.name) { return; }
  announcer.innerHTML = `${to.name} page has loaded`;
});

export default router